export const bannersApi = {
    list: {
        method: 'post',
        api: 'admin/banners/list'
    },
    add: {
      method: 'post',
      api: 'admin/banners/add'
    },
    edit: {
      method: 'post',
      api: 'admin/banners/edit'
    },
    get: {
      method: 'post',
      api: 'admin/banners/get'
    },
    del: {
      method: 'post',
      api: 'admin/banners/del'
    },
    changeStatus: {
      method: 'post',
      api: 'admin/banners/changeStatus'
    },
  }